import { render, staticRenderFns } from "./editFaqLocale.vue?vue&type=template&id=6a1fd267&scoped=true&lang=html&"
import script from "./editFaqLocale.vue?vue&type=script&lang=js&"
export * from "./editFaqLocale.vue?vue&type=script&lang=js&"
import style0 from "./editFaqLocale.vue?vue&type=style&index=0&id=6a1fd267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1fd267",
  null
  
)

export default component.exports